import { Link } from "react-router-dom";
import { formatViews, type FeedItem } from "@/components/feature/ContentCard";

interface VideoPreviewCardProps {
  item: FeedItem;
  onPlay: (item: FeedItem) => void;
}

export default function VideoPreviewCard({ item, onPlay }: VideoPreviewCardProps) {
  return (
    <div className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
        <Link to={`/detail/${item.id}`} aria-label={item.title}>
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 我爱搞`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
        <button
          type="button"
          onClick={() => onPlay(item)}
          aria-label={`播放 ${item.title}`}
          className="absolute inset-0 flex cursor-pointer items-center justify-center"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/90 text-primary-600 transition-transform duration-300 group-hover:scale-110">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </button>
        <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs text-background-50">
          {item.duration}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <Link to={`/detail/${item.id}`}>
          <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base line-clamp-2">
            {item.title}
          </h3>
        </Link>
        <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-play-circle-line text-[13px]"></i>
            </span>
            {formatViews(item.plays)} 次播放
          </span>
          <span className="whitespace-nowrap">{item.publishedAt}</span>
        </div>
      </div>
    </div>
  );
}